/**
 * @generated SignedSource<<433970906ff2242df996ef6c0e17f1fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BudgetData_project$data = {
  readonly id: string;
  readonly billable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"Chart_project" | "HighLevelBudgetNumbers_project" | "Totals_project" | "InvoiceChart_project">;
  readonly " $fragmentType": "BudgetData_project";
};
export type BudgetData_project$key = {
  readonly " $data"?: BudgetData_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetData_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetData_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Chart_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "currentMonthLastDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "currentYear",
          "variableName": "currentYear"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HighLevelBudgetNumbers_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Totals_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceChart_project"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billable",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "f10a6750ddce79eedf0670395fd6898d";

export default node;
